import React from "react";
import { siteConfig } from "../siteConfig";

const ReviewCard = ({ review }) => (
  <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col gap-4">
    <div className="flex gap-0.5">
      {Array.from({ length: review.rating }).map((_, i) => (
        <span key={i} className="text-yellow-400 text-lg">★</span>
      ))}
    </div>
    <p className="text-gray-600 text-sm leading-relaxed flex-1">"{review.text}"</p>
    <div>
      <div className="font-bold text-sm" style={{ color: siteConfig.colors.dark }}>{review.name}</div>
      {review.location && <div className="text-gray-400 text-xs">{review.location}</div>}
    </div>
  </div>
);

export default ReviewCard;
